<template>
  <el-form
    size="mini"
    ref="form"
    :model="formData"
    :rules="rules"
    label-position="top"
    v-loading.fullscreen.lock="loading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="业务时间" prop="receiveTime" size="small">
          <el-date-picker
            style="width:100%"
            format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.receiveTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :picker-options="pickerOptions"
            placeholder="请选择时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <TempEndTimeGroup
        ref="tempEndTimeGroup"
        :dispatchOrderNoList="dispatchOrderNoList"
      />
    </el-row>
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
import TempEndTimeGroup from './temp-endtime-group.vue'
export default {
  components: { TempEndTimeGroup },
  props: {
    listOrder: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      formData: {
        receiveTime: '',
      },
      rules: {
        receiveTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                new Date().getTime() <
                new Date(this.formData.receiveTime).getTime()
              ) {
                callback(new Error('提货时间不能大于当前时间'))
              } else {
                callback()
              }
            },
            trigger: ['change', 'blur'],
          },
          { required: true, message: '请选择提货时间', trigger: 'change' },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  computed: {
    $tempEndTimeGroup() {
      return this.$refs.tempEndTimeGroup
    },
    dispatchOrderNoList() {
      return this.listOrder.map((item) => item.dispatchOrderNo)
    },
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      if (!(await this.$tempEndTimeGroup.validate())) {
        return
      }
      const tempEndTimesGroup = Object.fromEntries(
        this.$tempEndTimeGroup
          .getData()
          .map((item) => [item.dispatchOrderNo, item.children])
      )

      const orderList = this.listOrder.map((item) => ({
        ...item,
        tempEndTimes: tempEndTimesGroup[item.dispatchOrderNo],
      }))

      this.$confirm(
        '确认要对当前的运输订单，进行【送达】操作吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.loading = true
        this.$api
          .carrierWaybillDetailIsReceiveApi({
            orderList,
            ...this.formData,
          })
          .then((res) => {
            this.loading = false
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
  },
}
</script>
